import React, { useState, useEffect } from "react";
import { LoginCart, SignupCart, SuggestedCourses } from "../components";
import { useDesktop } from "../hooks";
import { useDispatch, useSelector } from "react-redux";
import { StyledLink } from "../utils/button";
import { removeFromCart } from "../services/productsSlice";
import { removePlanFromCart } from "../services/plansSlice";
import styled from "styled-components";
import "../styles/cart.css";
import { selectUser } from "../services/userSlice";
import { useNavigate } from "react-router-dom";

const StyledDiv = styled.div`
  display: flex;

  p {
    color: rgba(10, 19, 124, 0.58) !important;
    margin-right: 0.2em;
    text-decoration: underline;
    cursor: pointer;
    font-size: 0.75em;

    @media (min-width: 801px) {
      font-size: 0.875em;
      padding-top: 1em;
    }
  }
`;

interface RootPlan {
  plans: {
    planItems: {
      type: string;
      title: string;
      details: string;
      show: number;
    }[];
  };
}

interface planItems {
  type: string;
  title: string;
  details: string;
  show: number;
}
interface cartItems {
  showPrice: number;
  banner: string;
  title: string;
  courseDetails: string;
}
interface RootCart {
  products: {
    cartItems: {
      showPrice: number;
      banner: string;
      title: string;
      courseDetails: string;
    }[];
  };
}

interface RootLogin {
  login: {
    isLoggedin: boolean;
  };
}

const Cart = () => {
  const checkLogin = useSelector((state: RootLogin) => state.login.isLoggedin);
  const cart = useSelector((state: RootCart) => state.products);
  const plan = useSelector((state: RootPlan) => state.plans.planItems);

  let cartTotalPrice = cart.cartItems
    .map((item) => item.showPrice)
    .reduce((prev, curr) => prev + curr, 0);
  let planTotalPrice = plan
    .map((item) => item.show)
    .reduce((prev, curr) => prev + curr, 0);

  const [style, setStyle] = useState({
    visibility: "hidden",
  } as React.CSSProperties);

  const [loginStyle, setloginStyle] = useState({
    visibility: "hidden",
  } as React.CSSProperties);

  const [login, setlogin] = useState({
    isLogin: false,
    isSignup: false,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [login]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(selectUser);

  const totalStyle = {
    marginTop: useDesktop() >= 801 && cart.cartItems.length < 1 ? "1em" : "0em",
  };

  function handleRemoveFromCart(item: cartItems) {
    dispatch(removeFromCart(item));
  }

  function handlePlanRemove(item: planItems) {
    dispatch(removePlanFromCart(item));
  }

  function checkout() {
    if (!user?.emailVerified) {
      setStyle((prevStyle) => {
        return {
          ...prevStyle,
          visibility: "visible",
        };
      });
      setlogin((prevLogin) => {
        return {
          ...prevLogin,
          isSignup: !login.isSignup,
        };
      });
    } else {
      navigate("/checkout");
    }
  }
  function handleClick() {
    setStyle((prevStyle) => {
      return {
        ...prevStyle,
        visibility: "hidden",
      };
    });
    setloginStyle((prevStyle) => {
      return {
        ...prevStyle,
        visibility: "hidden",
      };
    });
    setlogin({
      isLogin: false,
      isSignup: false,
    });
  }

  function switchLogin() {
    setlogin((prevLogin) => {
      return {
        ...prevLogin,
        isLogin: !login.isLogin,
        isSignup: !login.isSignup,
      };
    });

    if (!login.isLogin) {
      setStyle((prevStyle) => {
        return {
          ...prevStyle,
          visibility: "hidden",
        };
      });
      setloginStyle((prevStyle) => {
        return {
          ...prevStyle,
          visibility: "visible",
        };
      });
    }
  }

  function switchSignup() {
    setlogin((prevLogin) => {
      return {
        ...prevLogin,
        isSignup: !login.isSignup,
        isLogin: !login.isLogin,
      };
    });
    if (!login.isSignup) {
      setStyle((prevStyle) => {
        return {
          ...prevStyle,
          visibility: "visible",
        };
      });
      setloginStyle((prevStyle) => {
        return {
          ...prevStyle,
          visibility: "hidden",
        };
      });
    }
  }

  const cartItems = cart.cartItems?.map((items, i) => (
    <div
      key={i}
      className="cart-card"
    >
      <img
        style={{ borderRadius: "10px" }}
        src={items.banner}
        alt="course"
      />
      <div>
        <h4>{items.title}</h4>
        <p>{items.courseDetails}</p>

        <StyledDiv>
          <p>Edit | </p>
          <p onClick={() => handleRemoveFromCart(items)}>Remove | </p>
          <p>Save for Later</p>
        </StyledDiv>
      </div>
    </div>
  ));
  const planItems = plan?.map((plan, i) => (
    <div
      key={i}
      className="cart-plan-card"
    >
      <div>
        <h2>{plan.type} Plan</h2>
      </div>

      <div>
        <h4>{plan.title}</h4>
        <p>{plan.details}</p>
        <StyledDiv>
          <p>Edit | </p>
          <p onClick={() => handlePlanRemove(plan)}>Remove | </p>
          <p>Save for Later</p>
        </StyledDiv>
      </div>
    </div>
  ));

  return (
    <>
      <main className="cart">
        <section className="cart-container">
          <h3>Shopping Cart</h3>
          <p>
            {cart.cartItems.length + plan.length}{" "}
            {cart.cartItems.length > 1 || plan.length > 1
              ? `Courses`
              : `Course`}{" "}
            in Cart
          </p>
          <div className="cart-showcase-cont">
            <div className="cart-showcase-cont-card">
              {cartItems}
              {planItems}
            </div>

            <div
              className="cart-total"
              style={totalStyle}
            >
              <h5>Total</h5>

              {cart.cartItems.length >= 1 && (
                <p>N{cartTotalPrice.toLocaleString()}</p>
              )}
              {plan.length >= 1 && <p>${planTotalPrice.toLocaleString()}</p>}

              {/* authentication to occur here */}

              <div>
                <StyledLink
                  as="button"
                  onClick={checkout}
                  disabled={cart.cartItems.length < 1}
                  className="cart-checkout-button"
                  style={{
                    opacity: cart.cartItems.length < 1 ? 0.7 : 1,
                    cursor:
                      cart.cartItems.length < 1 ? "not-allowed" : "pointer",
                  }}
                >
                  Checkout
                </StyledLink>
              </div>
            </div>
          </div>
        </section>

        <section className="cart-auth">
          <SignupCart
            style={style}
            handleClick={handleClick}
            switchLogin={switchLogin}
          />
          <LoginCart
            loginStyle={loginStyle}
            handleClick={handleClick}
            switchSignup={switchSignup}
          />
        </section>
      </main>
      <SuggestedCourses heading={"Suggested For You"} />
    </>
  );
};

export default Cart;
